var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:[_vm.doShowPreviewImage ? 'print-only' : 'd-none'],attrs:{"src":_vm.previewImage + '/full/,' + _vm.height + '/0/default.jpg'}})}
var staticRenderFns = []

export { render, staticRenderFns }